module.exports = __webpack_public_path__ + "static/media/immune.c60fd788.svg";